import type { insuranceMonitorSettingsApiSpec } from "@wingspanhq/wingspan-api-types";
import { monitorSettingsService } from "./service";

type IInsuranceCoverageMonitorSettings =
  insuranceMonitorSettingsApiSpec.InsuranceCoverageMonitorSettings;

export const getMonitorSettingsItem = async (
  monitoredSettingsId: string
): Promise<IInsuranceCoverageMonitorSettings> => {
  const { data } =
    await monitorSettingsService.get<IInsuranceCoverageMonitorSettings>(
      `/${monitoredSettingsId}`
    );

  return data;
};
